import FmdBadRoundedIcon from '@mui/icons-material/FmdBadRounded';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import PaymentStatusAuthorized from '../../svg-icons/PaymentStatusAuthorized';
import PaymentStatusCanceled from '../../svg-icons/PaymentStatusCanceled';
import PaymentStatusCaptured from '../../svg-icons/PaymentStatusCaptured';
import PaymentStatusFailed from '../../svg-icons/PaymentStatusFailed';
import PaymentStatusInProgress from '../../svg-icons/PaymentStatusInProgress';
import PaymentStatusNotAuthorized from '../../svg-icons/PaymentStatusNotAuthorized';
import PaymentStatusPartial from '../../svg-icons/PaymentStatusPartial';
import PaymentStatusRefunded from '../../svg-icons/PaymentStatusRefunded';
import PaymentStatusSAVFree from '../../svg-icons/PaymentStatusSAVFree';
import PaymentStatusSAVPaid from '../../svg-icons/PaymentStatusSAVPaid';
import PaymentStatusTotal from '../../svg-icons/PaymentStatusTotal';
import PaymentStatusWaiting from '../../svg-icons/PaymentStatusWaiting';
import ErrorBoundary from '../errors/ErrorBoundary';
import InternalServerError from '../errors/InternalServerError.jsx';

const selectIconBasedOnPaymentStatus = (status) => {
  switch (status) {
    case 'payment_free':
      return <PaymentStatusSAVFree />;
    case 'payment_not_requested':
      return <PaymentStatusNotAuthorized />;
    case 'payment_waiting':
      return <PaymentStatusWaiting />;
    case 'payment_pending':
      return <PaymentStatusInProgress />;
    case 'payment_failed':
      return <PaymentStatusFailed />;
    case 'payment_canceled':
      return <PaymentStatusCanceled />;
    case 'payment_authorized':
      return <PaymentStatusAuthorized />;
    case 'payment_captured':
      return <PaymentStatusCaptured />;
    case 'payment_refunded':
      return <PaymentStatusRefunded />;
    default:
      return (
        <>
          <FmdBadRoundedIcon />
          <PaymentStatusSAVPaid />
          <PaymentStatusPartial />
          <PaymentStatusTotal />
        </>
      );
  }
};

const PaymentStatusIcon = (props) => {
  const { paymentStatus } = props;

  return (
    <ErrorBoundary
      fallback={<InternalServerError />}
      source="PaymentStatusIcon"
    >
      <Tooltip placement="top-start" title={`${paymentStatus}`}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          {paymentStatus ? selectIconBasedOnPaymentStatus(paymentStatus) : null}
        </Box>
      </Tooltip>
    </ErrorBoundary>
  );
};

export default PaymentStatusIcon;
